module.exports = __webpack_public_path__ + "static/media/cal.11ffa340.svg";